module.exports = __webpack_public_path__ + "media/images/shark/BlueOcean_3-p-1080-2f22214516e4a856be1075a6c146575a.jpeg";